import styled from 'styled-components';
import Variables from '../../assets/styleVariables';

export const SortContainer = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	cursor: pointer;
	-webkit-touch-callout: none; /* iOS Safari */
	-webkit-user-select: none; /* Safari */
	-khtml-user-select: none; /* Konqueror HTML */
	-moz-user-select: none; /* Firefox */
	-ms-user-select: none; /* Internet Explorer/Edge */
	user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
	.sort-icon-container {
		padding-left: 8px;
		i {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 10px !important;
			height: 8px !important;
			&:before {
				font-size: 7px !important;
				margin-left: 0;
				color: ${Variables.colors.complementary_600};
				font-weight: ${Variables.font_weight.bold};
			}
		}
		.sort-active {
			&:before {
				color: ${Variables.colors.complementary_800};
			}
		}
	}
	.text-container {
		font-size: ${Variables.font_sizes.x_medium};
		color: ${Variables.colors.complementary_700};
	}
`;